import createOrUpdateHiddenField from './createOrUpdateHiddenField';

const injectHertzLink = (form) => {
	const params = new URLSearchParams(window.location.search);
	const formId = form.querySelector('[name="custom.form.id"]')?.value;
	const isCustomForm = formId && formId === 'hertzcarsales_contact_19';
	const hasNeededParams = params.get('hertzlink') || params.get('VIN');

	const isValidEntry = isCustomForm && hasNeededParams;
	let infoMap;

	if (isValidEntry) {
		const hertzlink = params.get('hertzlink');

		if (hertzlink) {
			infoMap = JSON.parse(atob(hertzlink.replaceAll(' ', '+')));
		} else {
			infoMap = {
				make: params.get('MAKE'),
				model: params.get('MODEL'),
				trim: params.get('TRIM'),
				year: params.get('YEAR'),
				vin: params.get('VIN'),
				price: params.get('PRICE')
			};
		}

		if (infoMap?.make) {
			createOrUpdateHiddenField(form, 'make', infoMap.make);
		}
		if (infoMap?.model) {
			createOrUpdateHiddenField(form, 'model', infoMap.model);
		}
		if (infoMap?.trim) {
			createOrUpdateHiddenField(form, 'trim', infoMap.trim);
		}
		if (infoMap?.year) {
			createOrUpdateHiddenField(form, 'year', infoMap.year);
		}
		if (infoMap?.vin) {
			createOrUpdateHiddenField(form, 'vin', infoMap.vin);
		}
		if (infoMap?.price) {
			createOrUpdateHiddenField(
				form,
				'_custom=PRICE=0=internetPrice',
				infoMap.price
			);
		}
	}

	return infoMap;
};

export default injectHertzLink;
